import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  CompanyHoliday,
  CreatePaidTimeOffPolicyContract,
  PaidTimeOffPolicy,
  UpdatePaidTimeOffPolicyContract
} from "winslow-core";

const { baseApi } = config;

export async function apiGetPaidTimeOffPoliciesForWorkspace(workspaceId: string): 
Promise<PaidTimeOffPolicy[] | null> {
  const fetchURL = `${baseApi}/pto-policies/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffPolicysForWorkspace");
}

export async function apiGetPaidTimeOffPolicy(id: string): 
Promise<PaidTimeOffPolicy | null> {
  const fetchURL = `${baseApi}/pto-policies/pto-policy/${id}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffPolicy");
}

export async function apiCreatePaidTimeOffPolicy(
  payload: CreatePaidTimeOffPolicyContract["Body"]
): Promise<PaidTimeOffPolicy | null> {
  const fetchURL = `${baseApi}/pto-policies/create`;
  return await postRequest(fetchURL, payload, "API/apiCreatePaidTimeOffPolicy");
}

export async function apiUpdatePaidTimeOffPolicy(
  payload: UpdatePaidTimeOffPolicyContract["Body"]
): Promise<PaidTimeOffPolicy | null> {
  const fetchURL = `${baseApi}/pto-policies/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdatePaidTimeOffPolicy");
}

export async function apiDeletePaidTimeOffPolicy(id: string): 
Promise<PaidTimeOffPolicy | null> {
  const fetchURL = `${baseApi}/pto-policies/delete/${id}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffPolicy");
}

export async function apiGetCompanyHolidaysForWorkspace(workspaceId: string): 
Promise<CompanyHoliday[] | null> {
  const fetchURL = `${baseApi}/pto-policies/holidays/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetCompanyHolidaysForWorkspace");
}

